export { ProductRating } from "./ProductRating";
export type { ProductRatingProps } from "./ProductRating";
